export default {
  zh: {
    step: '步骤',
    joinUs: '三步加入我们',
    stepList: [{
      title: '获得一个联盟账号',
      detailDescribe: '在该页面注册一个联盟账号，如果您已经是 Plex加速器会员则可申请升级成联盟会员。'
    }, {
      title: '分享链接或者邀请码',
      detailDescribe: '登录账号，在个人中心找到您的专属推广链接和邀请码。其他人通过您的链接完成注册或者注册时填写您的邀请码都将成为您的好友。'
    }, {
      title: '申请提现',
      detailDescribe: '当您账户中的推广收入超过 ￥100，每月我们将在次月 15 号前将奖励转至到您的 PayPal 账户。'
    }]
  },
  en: {
    step: 'Step',
    joinUs: 'Join Us with Three Steps',
    stepList: [{
      title: 'Create an Affiliate Account',
      detailDescribe: 'You can create an affiliate account via this page. If you are already a PlexVPN user you can apply to upgrade to an affiliate.'
    }, {
      title: 'Share Your Affiliate Link or Affiliate Code',
      detailDescribe: 'Sign in to your account and get your unique affiliate link and affiliate code in the dashboard. People who register via your affiliate link or affiliate code will be your friends.'
    }, {
      title: 'Apply to Withdrawal',
      detailDescribe: 'We pay affiliate commissions on the 15th of every month for the previous month’s commissions. If your commission for a given month total over $50, we will pay you via PayPal.'
    }]
  }
}



// WEBPACK FOOTER //
// ./src/components/affiliateProgram/joinStep/lang.js